module.exports = __webpack_public_path__ + "img/planning.007c3d3c.svg";